import { Marker } from "@react-google-maps/api";
import React from "react";
import useMediaQuery from "../Common/Hooks/useMediaQuery.jsx";
import Map from "../Common/Map/index.jsx";

const ContactMapApp = (props) => {
  const zoom = props.zoom;
  const customClass = "contactmap--map";
  const icon = "https://www.cresa.com/images/icons/map-pin-blue.png";
  const shift = zoom >= 15 ? 0.01 : 0.025 * 2 ** (14 - zoom);
  const isMobile = useMediaQuery(980);
  const locations = props.locations;

  return (
    <section>
      <div className="contactmap">
        <Map
          zoom={zoom}
          draggable={false}
          center={{
            lat: props.latitudecenter,
            lng: props.longitudecenter + (isMobile ? 0 : shift),
          }}
          customClass={customClass}
        >
          {locations.map(
            (location) =>
              location && (
                <Marker
                  key={location.address1}
                  position={{ lat: location.latitude, lng: location.longitude }}
                  icon={icon}
                  title={location.address1}
                />
              ),
          )}
        </Map>
        <aside className="contactmap--box">
          <h3 className="h3-alt-lg">{props.name}</h3>
          <div className="contactmap--box-data">
            <div>
              <div className="addresses">
                {locations.map(
                  (location) =>
                    location && (
                      <div className="address">
                        <div className="loc">
                          <p>{location.address1}</p>
                          <p>{location.address2}</p>
                          <p>{location.address3}</p>
                          {location.address4 && <p>{location.address4}</p>}
                        </div>
                        <div className="contacts">
                          {location.phone && (
                            <a href={`tel:${location.phone}`}>
                              <p>{`Phone: ${location.phone}`}</p>
                            </a>
                          )}
                          {location.fax && <p>{`Fax: ${location.fax}`}</p>}
                          {location.email && (
                            <a href={`mailto:${location.email}`}>
                              <p>{`Email: ${location.email}`}</p>
                            </a>
                          )}
                        </div>
                      </div>
                    ),
                )}
              </div>

              {props.socials.rss && props.socials.rss.Url && (
                <a
                  className="rss-link"
                  target={props.socials.rss.Target}
                  href={props.socials.rss.Url}
                >
                  <p>RSS</p>
                </a>
              )}

              {props.socials && (
                <div className="social-links">
                  <ul>
                    {props.socials.facebook && (
                      <li>
                        <a
                          href={props.socials.facebook.Url}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img src="/images/icons/fb.svg" alt="facebook icon" />
                        </a>
                      </li>
                    )}
                    {props.socials.instagram && (
                      <li>
                        <a
                          href={props.socials.instagram.Url}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img
                            src="/images/icons/ig.svg"
                            alt="instagram icon"
                          />
                        </a>
                      </li>
                    )}
                    {props.socials.linkedin && (
                      <li>
                        <a
                          href={props.socials.linkedin.Url}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img
                            src="/images/icons/ln.svg"
                            alt="linked-in icon"
                          />
                        </a>
                      </li>
                    )}
                    {props.socials.twitter && (
                      <li>
                        <a
                          href={props.socials.twitter.Url}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img src="/images/icons/tw.svg" alt="twitter icon" />
                        </a>
                      </li>
                    )}
                    {props.socials.youtube && (
                      <li>
                        <a
                          href={props.socials.youtube.Url}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img src="/images/icons/yt.svg" alt="youtube icon" />
                        </a>
                      </li>
                    )}
                  </ul>
                </div>
              )}

              {props.freetext && (
                <div
                  className="freetext"
                  dangerouslySetInnerHTML={{ __html: props.freetext }}
                />
              )}
            </div>
          </div>
        </aside>
      </div>
    </section>
  );
};

export default ContactMapApp;
